// 判断是否是新格式的访客名（国家码-时间戳，如 CN-151910 或 LAN-151910）
export function isVisitorName(name) {
  if (!name) return false;
  // 匹配格式：2-3个大写字母 + - + 6位数字
  return /^[A-Z]{2,3}-\d{6}$/.test(name);
}

// 解析访客名，返回 { countryCode, time }
export function parseVisitorName(name) {
  const parts = name.split('-');
  return {
    countryCode: parts[0],
    time: parts[1],
  };
}

// 国家码转国旗 emoji
export function countryCodeToFlag(countryCode) {
  if (!countryCode || countryCode === 'LAN' || countryCode === 'XX') return '🌐';
  if (countryCode.length !== 2) return '🌐';
  return countryCode
    .toUpperCase()
    .replace(/./g, c => String.fromCodePoint(c.charCodeAt(0) + 127397));
}

// 格式化显示名字
export function formatVisitorName(name) {
  if (!isVisitorName(name)) return name;
  const { countryCode, time } = parseVisitorName(name);
  const flag = countryCode === 'LAN' ? '🏠' : countryCodeToFlag(countryCode);
  return `${flag} ${name}`;
}